import axiosInstance from '../axiosInterceptor/axiosInstance'

const updateUserData = async (data) => {
  const { ...restData } = data || {}
  const url = '/users/me'
  return axiosInstance.patch(url, restData)
}

export default updateUserData
